export const GET_USER_EVENT_OVERVIEW_ROLES_BEGIN = 'GET_USER_EVENT_OVERVIEW_ROLES_BEGIN';
export const GET_USER_EVENT_OVERVIEW_ROLES_ERROR = 'GET_USER_EVENT_OVERVIEW_ROLES_ERROR';
export const GET_USER_EVENT_OVERVIEW_ROLES_SUCCESS = 'GET_USER_EVENT_OVERVIEW_ROLES_SUCCESS';